import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ClientWithDesignAdminCSS } from '@shared/constants/site-config-client-exceptions';
import { ClientPath } from '@shared/models/client-path.enum';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { CustomizableAssets } from '@shared/shared/interfaces/custom-assets.interfaces';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as CustomAssetActions from '../actions/custom-assets.actions';

@Injectable()
export class CustomAssetEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private siteSettingsService: SiteSettingsService
  ) {}

  public getCustomAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomAssetActions.GET_CUSTOM_ASSETS),
      switchMap(() => {
        const isClientWithDesignAdminCSS = ClientWithDesignAdminCSS.includes(
          this.siteSettingsService.settings.fe_configuration.path as ClientPath
        );
        if (isClientWithDesignAdminCSS) {
          return of(new CustomAssetActions.GetCustomAssetsSuccess({} as CustomizableAssets));
        }
        return this.http.get(ApiEndpoint.CUSTOMISABLE_ASSETS).pipe(
          map((result: CustomizableAssets) => {
            return new CustomAssetActions.GetCustomAssetsSuccess(result);
          }),
          catchError((err: any) => {
            return of(new CustomAssetActions.GetCustomAssetsFail(err));
          })
        );
      })
    )
  );
}
